import { render, staticRenderFns } from "./paginator.vue?vue&type=template&id=4d220724&scoped=true&lang=pug"
import script from "./paginator.vue?vue&type=script&lang=js"
export * from "./paginator.vue?vue&type=script&lang=js"
import style0 from "./paginator.vue?vue&type=style&index=0&id=4d220724&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d220724",
  null
  
)

export default component.exports